module.exports = " <slot><slot> </slot></slot>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-tooltip/src/Tooltip.vue
// module id = 936
// module chunks = 2